import React from "react";
import "./CTABox.css";

export default function CTABox({children, url, label, image}){
    if (!image)
    {
        return (
            <div className="mobile-pad-top">
                <article className="ctabox">
                    {children}
                    <a href={url} className="cta-primary">{label}</a>
                </article>
            </div>
        )
    } else {
        return (
           <div className="mobile-pad-top">
                <article className="ctabox nopad">
                    <div class="boxcover" style={{backgroundImage: `url("https://api.vanarts.com/assets/${image}")`}}></div>
                    <div className="pad">
                        {children}
                        <a href={url} className="cta-primary">{label}</a>
                    </div>
                </article>
            </div>
        )
    }
}